export default "__VITE_ASSET__5407ed70__"